<script>
  import {
    Spinner,
    Input,
    ChoiceInput,
    Select,
    Pagination,
  } from "agnostic-svelte"
  import { navigate } from "svelte-routing"
  import { store } from "./store"
	

  const apikey = "d687412e7b53146b2631dc01974ad0a4"

  $: counties = fetch(
    `https://marketplace.api.healthcare.gov/api/v1/counties/by/zip/${store.userd.zip}?apikey=${apikey}`
  ).then((v) => v.json())
  const quickopts = (o) =>
    o.map((v) =>
      Array.isArray(v)
        ? { value: v[0], label: v[1] }
        : { value: v, label: v.toString() }
    )

  let year = 2022,
    year_opts = quickopts([2020, 2021, 2022])
  let order = "asc",
    order_opts = quickopts([
      ["asc", "Ascending"],
      ["desc", "Descending"],
    ])

  let page = 1
  let limit = 10,
    limit_opts = quickopts([10, 20, 30])

  $: offset = (page - 1) * limit

  $: plansr = counties.then((counties) => {
    const c = counties.counties?.[0]
    if (!c) {
      console.error("No county found", counties)
      return
    }
    return fetch(
      `https://marketplace.api.healthcare.gov/api/v1/plans/search?apikey=${apikey}`,
      {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          household: {
            income: Number(store.userd.income),
            people: store.userd.people.map((p) => ({
              age: Number(p.age),
              gender: p.sex === "M" ? "Male" : "Female",
            })),
            has_married_couple: store.userd.people.some(
              (p) => p.name === "Spouse"
            ),
          },
          market: "Individual",
          place: {
            countyfips: c.fips,
            state: c.state,
            zipcode: c.zipcode,
          },
          limit: Number(limit),
          offset: Number(offset),
          order,
          year: Number(year),
        }),
      }
    ).then((v) => v.json())
  })
</script>

<div class="flex flex-column items-center" style="gap:1em">
	
  {#await plansr}
    <Spinner />
  {:then plansr}
	<Pagination
        bind:current={page}
        total={Math.ceil(plansr.total / limit)}
      />
    <div class="flex ">
      <div
        class="flex flex-column p8"
        style="width:40%;gap: .5em;text-align:left"
      >
        <h3 style="text-align:center">Filters</h3>

        <h4>Year</h4>
        <Select
          bind:singleSelected={year}
          options={year_opts}
          labelCopy="Year"
        />
        <h4>Order</h4>
        <Select
          bind:singleSelected={order}
          options={order_opts}
          labelCopy="Order"
        />

        <!-- <h4 >Limit</h4>
        <Select
          bind:singleSelected={limit}
          options={limit_opts}
          labelCopy="Limit"
        /> -->
      </div>
      <div class="flex flex-column container " style="width:60%">
        {#each plansr.plans as plan}
          <div on:click={()=>navigate (`/plans/${plan.id}`)} class="round p12 plan" style="width:100%;border:gray solid 1px">
            <h4>{plan.name}</h4>
					</div>
        {/each}
      </div>
    </div>
    
      <Pagination
        bind:current={page}
        total={Math.ceil(plansr.total / limit)}
      />
    
  {/await}
</div>

<style>
	.plan{
		transition: all .5s;
		cursor: pointer;
		
		background: transparent;
	}
	.plan:hover{
		background: var(--agnostic-gray-dark);
	}
</style>
